import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_zufqgcwjpa: FaireBrandEntity = {
  token: "b_zufqgcwjpa",
  type: "brand",
  name: "Feral Foods",
  avatarUrl:
    "https://cdn.faire.com/fastly/1c26a366ad2fd18619dfba1c0ace4830e4c7cb693eb8808ee33d0c4705abed68.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/be4b81e8f9582abcff3e6635f6affbd8690b313053f9e6ef6d3f8b09b1823bc7.png",
  logoUrl:
    "https://cdn.faire.com/fastly/1c26a366ad2fd18619dfba1c0ace4830e4c7cb693eb8808ee33d0c4705abed68.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/be4b81e8f9582abcff3e6635f6affbd8690b313053f9e6ef6d3f8b09b1823bc7.png",
  location: "Santa Ynez, CA, USA",
  minimumOrderDollars: 208,
  rating: 5,
  reviewCount: 2,
  isTopShop: true,
  isInsider: true,
  description:
    "Feral Foods crafts pleasure rich pantry staples that reawaken the body’s innate intelligence. Rooted in the abundance and beauty of California’s Santa Ynez Valley, our one hundred percent organic offerings honor the seasons of nature and the wisdom of ancient plants. Each small batch creation is soulfully sourced to nourish the nervous system, support holistic well being, and bring us back into relationship with the natural world.\n\nEverything at Feral Foods is an extension of our home and is infused with craftsmanship, love, and intention. Our food is a sensual return to real, nourishing meals for those who crave depth, ritual, and resonance in their daily lives. Whether steeped, stirred, sprinkled, or lit, these offerings invite you to slow down and savor what is real while reconnecting with your natural nature and embodying a more grounded, meaningful way of living.\n\nElevated simplicity. Food as ceremony.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:53:06.463Z",
    importedBy: "entity-db-cli",
  },
};
